const autopricingTableHeaders = [
  {
    text: "Send country",
    value: "sendingCountryIso3",
    filterType: "text",
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  },
  {
    text: "Sending currency",
    value: "sendingCurrency",
    filterType: "text",
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  },
  {
    text: "Receive country",
    value: "receiveCountryIso3",
    filterType: "text",
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  },
  {
    text: "Receiving currency",
    value: "receiveCurrency",
    filterType: "text",
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  },
  {
    text: "Product",
    value: "serviceCode",
    filterType: "text",
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  },
  {
    text: "Segment",
    value: "segment",
    sortable: false,
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  },
  {
    text: "Desired mark-up from provider rate",
    value: "marginDesired",
    filterType: "range"
  },
  {
    text: "Sending currency - USD",
    value: "sendingCurrencyUsdRate",
    sortable: false
  },
  {
    text: "USD - destination currency",
    value: "usdReceiveCurrencyRate",
    sortable: false
  },
  {
    text: "Market rate",
    value: "marketRate",
    filterType: "range"
  },
  {
    text: "Provider rate",
    value: "providerRate",
    filterType: "range"
  },
  {
    text: "Provider name",
    value: "provider",
    filterType: "text"
  },
  ...(process.env.VUE_APP_LEGACY_FIRST_TRANSACTION_ENABLED !== 'false' ? [
    {
      text: "1st Rate Enabled",
      value: "firstTransactionRateDiscountEnabled",
      sortable: false
    },
    {
      text: "% for 1st Transaction rate",
      value: "firstTransactionRateDiscount"
    }
  ] : []),
  {
    text: "Customer Rate",
    value: "calcEndUserRate",
    filterType: "range"
  },
  {
    text: "Rate calculated automatically",
    value: "automaticallyRate",
    sortable: false
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  }
];

const autopricingTableUploadPreviewHeaders = [
  {
    text: "Send country",
    value: "sendingCountryIso3",
    filterType: "text"
  },
  {
    text: "Sending currency",
    value: "sendingCurrency",
    filterType: "text",
  },
  {
    text: "Receive country",
    value: "receiveCountryIso3",
    filterType: "text"
  },
  {
    text: "Receiving currency",
    value: "receiveCurrency",
    filterType: "text"
  },
  {
    text: "Product",
    value: "serviceCode",
    filterType: "text"
  },
  {
    text: "Segment",
    value: "segment",
    filterType: "text"
  },
  {
    text: "Desired mark-up from provider rate",
    value: "marginDesired",
    filterType: "range"
  },
  {text: "Type of change", value: "type"},
  {text: "Provider", value: "provider"}
];

const autopricingFilters = [
  {
    text: "Send country",
    value: "sendingCountryIso3",
    filterType: "text"
  },
  {
    text: "Sending currency",
    value: "sendingCurrency",
    filterType: "text"
  },
  {
    text: "Receive country",
    value: "receiveCountryIso3",
    filterType: "text"
  },
  {
    text: "Receiving currency",
    value: "receiveCurrency",
    filterType: "text"
  },
  {
    text: "Product",
    value: "serviceCode",
    filterType: "text"
  },
  {
    text: "Desired mark-up from provider rate",
    value: "marginDesired",
    filterType: "range"
  },
  {
    text: "Market rate",
    value: "marketRate",
    filterType: "range"
  },
  {
    text: "Provider rate",
    value: "providerRate",
    filterType: "range"
  },
  {
    text: "Provider name",
    value: "provider",
    filterType: "text"
  },
  {
    text: "Customer Rate",
    value: "calcEndUserRate",
    filterType: "range"
  },
  {
    text: "Corner Cases",
    value: "cornerCases",
    filterType: "multiple",
    items: []
  }
];

const safeGuardingTransactionSummaryFields = [
  {
    text: "Fees Payment Reference:",
    value: "feesPaymentReference"
  },
  {
    text: "Founds Payment Reference:",
    value: "foundsPaymentReference"
  },
  {
    text: "Need To Safe Guard:",
    value: "needToSafeGuard"
  },
  {
    text: "Need To Safe Guard GBP:",
    value: "needToSafeGuardGbp"
  },
  {
    text: "Transactions Amount:",
    value: "transactionsAmount"
  },
  {
    text: "Fees To Move:",
    value: "feesToMove"
  },
  {
    text: "Fees To Move GBP:",
    value: "feesToMoveGbp"
  },
  {
    text: "Bank Currency:",
    value: "bankCurrency"
  },
  {
    text: "Rate:",
    value: "rate"
  },
];

const safeGuardingWalletsSummariesFields = [
  {
    text: "End Balance:",
    value: "endBalance"
  },
  {
    text: "Currency:",
    value: "currency"
  }
];

const safeguardingTenantFields = [
    {
        text: "Need To Safe Guard (GBP):",
        value: "needToSafeGuard"
    },
    {
        text: "Need To Safe Guard (EUR):",
        value: "needToSafeGuardInAdditionalCurrency"
    },
    {
        text: "Fees To Move (GBP):",
        value: "feesToMove"
    },
    {
        text: "Fees To Move (EUR):",
        value: "feesToMoveInAdditionalCurrency"
    },
    {
        text: "Total Wallets:",
        value: "totalWallets"
    }
];

const feesTableHeaders = [
  {
    text: "Send Country Code",
    value: "sendCountryCode",
    filterType: "text",
  },
    {
        text: "Send Currency Code",
        value: "sendCurrencyCode",
        filterType: "text",
    },
  {
    text: "Receive Country Code",
    value: "receiveCountryCode",
    filterType: "text",
  },
  {
    text: "Receive Currency Code",
    value: "receiveCurrencyCode",
    filterType: "text",
  },
  {
    text: "Pay Out Method",
    value: "payOutMethod",
    filterType: "text",
  },
  {
    text: "Type",
    value: "type",
    filterType: "text",
  },
  {
    text: "Min Amount",
    value: "minAmount",
    filterType: "range",
  },
  {
    text: "Created Date",
    value: "createdDate",
    filterType: "text",
  },
  {
    text: "Value",
    value: "value",
    filterType: "range",
  },
  {
    text: "Pay In Method",
    value: "payInMethod",
    filterType: "text",
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  }
];

const feesTableFilters = [
  {
    text: "Send Country Code",
    value: "sendCountryCode",
    filterType: "text",
  },
    {
        text: "Send Currency Code",
        value: "sendCurrencyCode",
        filterType: "text",
    },
  {
    text: "Receive Country Code",
    value: "receiveCountryCode",
    filterType: "text",
  },
  {
    text: "Receive Currency Code",
    value: "receiveCurrencyCode",
    filterType: "text",
  },
  {
    text: "Pay Out Method",
    value: "payOutMethod",
    filterType: "text",
  },
  {
    text: "Type",
    value: "type",
    filterType: "text",
  },
  {
    text: "Min Amount",
    value: "minAmount",
    filterType: "range",
  },
  {
    text: "Created Date",
    value: "createdDate",
    filterType: "text",
  },
  {
    text: "Value",
    value: "value",
    filterType: "range",
  },
  {
    text: "Pay In Method",
    value: "payInMethod",
    filterType: "text",
  }
];

const differenceInDestCountriesConfigTableHeaders = [
  {
    text: "Destination Country code",
    value: "countryIso3",
    filterType: "text",
  },
  {
    text: "Destination Currency code",
    value: "currencyCode",
    filterType: "text",
  },
  {
    text: "Payout Type",
    value: "payoutType",
    filterType: "text",
  },
  {
    text: "Provider Name",
    value: "partnerProviderName",
    filterType: "text",
  },
  {
    text: "Status",
    value: "statusName",
    filterType: "text",
  },
  {
    text: "Comment",
    value: "comment",
    filterType: "text",
  },
];

const summariesTableHeaders = [
  {
    text: "All pricing records count",
    value: "totalCount",
  },
  {
    text: "Automated records count",
    value: "automatedCount",
  },
  {
    text: "Manual records count",
    value: "manualCount",
  },
];

const missingCorridorsTableHeaders = [
  {
    text: "Sending Country",
    value: "sendingCountryIso3",
    filterType: "text",
  },
  {
    text: "Sending Currency",
    value: "sendingCurrency",
    filterType: "text",
  },
  {
    text: "Receiving Country",
    value: "receiveCountryIso3",
    filterType: "text",
  },
  {
    text: "Receiving Currency",
    value: "receiveCurrency",
    filterType: "text",
  },
  {
    text: "Service Code",
    value: "serviceCode",
    filterType: "text",
  },
];

const deviatedEndRateFromMarketTableHeaders = [
  {
    text: "Sending Country",
    value: "sendingCountryIso3",
    filterType: "text",
  },
  {
    text: "Sending Currency",
    value: "sendingCurrency",
    filterType: "text",
  },
  {
    text: "Receiving Country",
    value: "receiveCountryIso3",
    filterType: "text",
  },
  {
    text: "Receiving Currency",
    value: "receiveCurrency",
    filterType: "text",
  },
  {
    text: "Service Code",
    value: "serviceCode",
    filterType: "text",
  },
  {
    text: "Market rate",
    value: "marketRate",
    filterType: "text",
  },
  {
    text: "Automated rate",
    value: "calcEndUserRate",
    filterType: "text",
  },
  {
    text: "Manual rate",
    value: "manualRate",
    filterType: "text",
  },
  {
    text: "Provider Rate",
    value: "providerRate",
    filterType: "text",
  },
  {
    text: "Provider Name",
    value: "provider",
    filterType: "text",
  },
];

const existingManualRatesTableHeaders = [
  {
    text: "Sending Country",
    value: "sendingCountryIso3",
    filterType: "text",
  },
  {
    text: "Receiving Country",
    value: "receiveCountryIso3",
    filterType: "text",
  },
  {
    text: "Receiving Currency",
    value: "receiveCurrency",
    filterType: "text",
  },
  {
    text: "Service Code",
    value: "serviceCode",
    filterType: "text",
  },
  {
    text: "Manual Rate",
    value: "manualRate",
    filterType: "text",
  },
  {
    text: "Updated At",
    value: "updatedAt",
    filterType: "text",
  },
];

const providerRatesTableHeaders = [
  {
    text: "Reference Currency",
    value: "sourceCurrencyCode",
    filterType: "text",
  },
  {
    text: "Destination Currency",
    value: "destinationCurrency",
    filterType: "text",
  },
  {
    text: "Rate",
    value: "rate",
    filterType: "text",
  },
  {
    text: "Service Code",
    value: "serviceCode",
    filterType: "text",
  },
  {
    text: "Due Date",
    value: "dueDate",
    filterType: "text",
  },
  {
    text: "Sending Country",
    value: "sendingCountryIso3",
    filterType: "text",
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  }
];

const providerRatesTableFilters = [
  {
    text: "Destination Currency",
    value: "destinationCountry",
    filterType: "text",
  },
  {
    text: "Sending Country",
    value: "sendingCountryIso3",
    filterType: "text",
  }
];
const usersTableHeaders = [
  {
    text: "First Name",
    value: "firstName",
    filterType: "text",
  },
  {
    text: "Last Name",
    value: "lastName",
    filterType: "text",
  },
  {
    text: "Email",
    value: "email",
    filterType: "text",
  }
  ,
  {
    text: "Roles",
    value: "roles",
    filterType: "text",
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  }
];

const usersTableFilters = [
  {
    text: "Name",
    value: "userName",
    filterType: "text",
  }, {
    text: "Email",
    value: "email",
    filterType: "text",
  },

];
const auditLogRatesTableHeaders = [
  {
    text: "Send Country Code",
    value: "sendingCountryIso3",
    filterType: "text"
  },
  {
    text: "Receive Country Code",
    value: "receiveCountryIso3",
    filterType: "text"
  },
  {
    text: "Receiving currency",
    value: "receiveCurrency",
    filterType: "text"
  },
  {
    text: "Payout Method",
    value: "serviceCode",
    filterType: "text"
  },
  {
    text: "Created At",
    value: "createdAt",
    filterType: "text"
  },
  {
    text: "Updated At",
    value: "updatedAt",
    filterType: "text"
  },
  {
    text: "Payout Provider",
    value: "serviceCode",
    filterType: "text"
  },
  {
    text: "Desired Margin",
    value: "marginDesired",
    filterType: "text"
  },
  {
    text: "Calc End User Rate",
    value: "calcEndUserRate",
    filterType: "text"
  },
  {
    text: "Calc Gross Margin",
    value: "calcGrossMargin",
    filterType: "text"
  },
  {
    text: "Manual Rate",
    value: "manualRate",
    filterType: "text"
  },
  {
    text: "Provider Rate",
    value: "providerRate",
    filterType: "text"
  },
  {
    text: "Updated By",
    value: "updatedBy",
    filterType: "text"
  }
];

const auditLogRatesTableFilters = [
  {
    text: "Send country",
    value: "sendingCountryIso3",
    filterType: "text"
  },
  {
    text: "Receive country",
    value: "receiveCountryIso3",
    filterType: "text"
  },
  {
    text: "Receiving currency",
    value: "receiveCurrency",
    filterType: "text"
  },
  {
    text: "Payout Method",
    value: "serviceCode",
    filterType: "text"
  },
  {
    text: "Max Created Date",
    value: "maxCreatedDate",
    filterType: "date"
  },
  {
    text: "Only Manual Changes",
    value: "onlyManualChanges",
    filterType: "checkbox"
  },
  {
    text: "Desired Margin",
    value: "marginDesired",
    filterType: "range"
  }
];

const auditLogFeesTableHeaders = [
  {
    text: "Send Country",
    value: "sendCountryCode",
    filterType: "text"
  },
  {
    text: "Receive Country",
    value: "receiveCountryCode",
    filterType: "text"
  },
  {
    text: "Receiving currency",
    value: "receiveCurrencyCode",
    filterType: "text"
  },
  {
    text: "Payout Method",
    value: "payOutMethod",
    filterType: "text"
  },
  {
    text: "Created Date",
    value: "createdDate",
    filterType: "text"
  },
  {
    text: "Min Amount",
    value: "minAmount",
    filterType: "text"
  },
  {
    text: "Fee Type",
    value: "type",
    filterType: "text"
  },
  {
    text: "Fee Value",
    value: "value",
    filterType: "text"
  }
];

const auditLogFeesTableFilters = [
  {
    text: "Send country",
    value: "sendCountryCode",
    filterType: "text"
  },
  {
    text: "Receive country",
    value: "receiveCountryCode",
    filterType: "text"
  },
  {
    text: "Receiving currency",
    value: "receiveCurrencyCode",
    filterType: "text"
  },
  {
    text: "Payout method",
    value: "payOutMethod",
    filterType: "text"
  },
  {
    text: "Max Created Date",
    value: "maxCreatedDate",
    filterType: "date"
  }
];

const auditLogPayoutTableHeaders = [
  {
    text: "Source Currency",
    value: "sourceCurrencyCode",
    filterType: "text"
  },
  {
    text: "Destination Currency",
    value: "destinationCurrency",
    filterType: "text"
  },
  {
    text: "Payout Partner Name",
    value: "payoutPartnerName",
    filterType: "text"
  },
  {
    text: "Sending Country",
    value: "sendingCountryIso3",
    filterType: "text"
  },
  {
    text: "Rate",
    value: "rate",
    filterType: "text"
  },
  {
    text: "Updated By",
    value: "updatedBy",
    filterType: "text"
  },
  {
    text: "Created At",
    value: "createdAt",
    filterType: "text"
  }
];

const auditLogPayoutTableFilters = [
  {
    text: "Receive currency",
    value: "receiveCurrency",
    filterType: "text"
  },
  {
    text: "Max Created Date",
    value: "maxCreatedDate",
    filterType: "date"
  }
];

const payinFeesTableHeaders = [
  {
    text: "Source Country",
    value: "sourceCountryCode",
    filterType: "text"
  },
  {
    text: "Source Currency",
    value: "sourceCurrencyCode",
    filterType: "text"
  },
  {
    text: "Payment Method",
    value: "payInMethod",
    filterType: "text"
  },
  {
    text: "Payment Provider",
    value: "paymentProvider",
    filterType: "text"
  },
  {
    text: "Type",
    value: "type",
    filterType: "text"
  },
  {
    text: "Min Amount",
    value: "minAmount",
    filterType: "range"
  },
  {
    text: "Value",
    value: "value",
    filterType: "range"
  },
  {
    text: "Created Date",
    value: "createdDate",
    filterType: "text"
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    class: "grey lighten-4",
    cellClass: "grey lighten-5"
  }
];

const payinFeesTableFilters = [
  {
    text: "Source Country",
    value: "sourceCountryCode",
    filterType: "text"
  },
  {
    text: "Source Currency",
    value: "sourceCurrencyCode",
    filterType: "text"
  },
  {
    text: "Payment Method",
    value: "payInMethod",
    filterType: "text"
  },
  {
    text: "Payment Provider",
    value: "paymentProvider",
    filterType: "text"
  },
  {
    text: "Type",
    value: "type",
    filterType: "text"
  },
  {
    text: "Min Amount",
    value: "minAmount",
    filterType: "range"
  },
  {
    text: "Value",
    value: "value",
    filterType: "range"
  },
  {
    text: "Created Date",
    value: "createdDate",
    filterType: "text"
  }
];

export {
  autopricingTableHeaders,
  autopricingTableUploadPreviewHeaders,
  autopricingFilters,
  safeGuardingTransactionSummaryFields,
  safeGuardingWalletsSummariesFields,
  feesTableHeaders,
  feesTableFilters,
  differenceInDestCountriesConfigTableHeaders,
  summariesTableHeaders,
  missingCorridorsTableHeaders,
  deviatedEndRateFromMarketTableHeaders,
  existingManualRatesTableHeaders,
  providerRatesTableHeaders,
  providerRatesTableFilters,
  auditLogRatesTableHeaders,
  auditLogRatesTableFilters,
  auditLogFeesTableHeaders,
  auditLogFeesTableFilters,
  auditLogPayoutTableHeaders,
  auditLogPayoutTableFilters,
  usersTableHeaders,
  usersTableFilters,
  safeguardingTenantFields,
  payinFeesTableHeaders,
  payinFeesTableFilters
};
